<template>
  <section class="dxf-project-portfolio">
    <div class="dxf-project-portfolio__project-list">
      <div class="dxf-project-portfolio__project-list-cards">
        <div v-for="project in visibleProjects" class="dxf-project-portfolio__project-card">
          <a class="card text-decoration-none" :href="project.url">
            <img :src="project.primaryImage.url" class="card-img-top card--hover-grow" :alt="project.primaryImage.alt" />
            <div class="card-body">
              <h3 class="card-title">{{project.title}}</h3>
              <p class="card-subtitle">{{project.subtitle}}</p>
              <p class="card-text" v-html="project.summary"></p>
            </div>
          </a>
        </div>
      </div>
      <div class="dxf-project-portfolio__project-list-filters">
        <div class="dxf-project-portfolio__project-list-filters-title">
          <h3>Filter & Sort</h3>
        </div>
        <div class="dxf-project-portfolio__project-list-filters-buttons-container">
          <button class="dxf-project-portfolio__project-list-filters-button btn btn-outline-primary"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#SortCollapse"
                  aria-expanded="true"
                  aria-controls="collapseExample">
            Sort
            <i class="fas fa-sort-numeric-down-alt"></i>
          </button>
          <button class="dxf-project-portfolio__project-list-filters-button btn btn-outline-primary"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#FilterCollapse"
                  aria-expanded="true"
                  aria-controls="collapseExample">
            Filter ({{selectedFilters.length}})
            <i class="far fa-filter"></i>
          </button>
        </div>
        <div class="collapse dxf-project-portfolio__project-list-filters-sort" id="SortCollapse">
          <div class="dxf-project-portfolio__project-list-filters-sort-conteiner">
            <small>Sort</small>
            <select class="form-select" aria-label="Select sorting mode" v-model="sortingOption">
              <option value="0" selected>Date (newest to oldest)</option>
              <option value="1">Date (oldest to newest)</option>
              <option value="2">A-Z</option>
              <option value="3">Z-A</option>
            </select>
          </div>
        </div>
        <div class="collapse dxf-project-portfolio__project-list-filters-filter-container" id="FilterCollapse">
          <div class="dxf-project-portfolio__project-list-filters-filter">
            <div class="dxf-project-portfolio__project-list-filters-filter-header">
              <small class="dxf-project-portfolio__project-list-filters-filter-header-title">Filters</small>
              <div v-show="selectedFilters.length > 0" class="dxf-project-portfolio__filter-clear-btn" @click="clearAllFilters">
                <small>Clear all</small>
                <i class="far fa-times-circle"></i>
              </div>
            </div>
            <div class="d-flex flex-wrap my-3">
              <span v-for="(selectedFilter, i) in selectedFilters" class="dxf-project-portfolio__filter-tag" :key="i">
                {{selectedFilter.displayName}}
                <i class="fal fa-times fa-sm dxf-project-portfolio__filter-tag-icon" @click="handleFilterClick(selectedFilter)"></i>
              </span>
            </div>
          </div>
          <div class="dxf-project-portfolio__project-list-filters-filter-options">
            <div class="accordion accordion-lines">
              <div v-for="(filter, i) in availableFilters" class="accordion-item" :key="i">
                <h2 class="accordion-header" :id="`headingLines-${i}`">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="`#collapseLines-${i}`" aria-expanded="false" :aria-controls="`#collapseLines-${i}`">
                    {{filter.displayName}}
                    <i class="fal fa-angle-down" @click="handleFilterClick(selectedFilter)"></i>
                  </button>
                </h2>
                <div :id="`collapseLines-${i}`" class="accordion-collapse collapse" :aria-labelledby="`collapseLines-${i}`">
                  <div class="accordion-body">
                    <div class="d-flex flex-wrap">
                      <span v-for="(option, i) in filter.options" :class="{selected: option.selected}" class="dxf-project-portfolio__filter-tag dxf-project-portfolio__filter-tag--gray" @click="handleFilterClick(option)" :key="i">
                        {{option.displayName}}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row dxf-project-portfolio__pagination my-5">
      <nav aria-label="pagination">
        <ul class="pagination">

          <template class="icon-wrapper">
            <li class="page-item page-icon" @click="decreasePagerOffsetIn(1)">
              <a :class="{disabled: pagerOffset <= 0}" class="page-link" aria-label="Next">
                <span aria-hidden="true"><i class="far fa-chevron-double-left"></i></span>
              </a>
            </li>

            <li class="page-item page-icon" @click="decreaseSelectedPageIn(1)">
              <a :class="{disabled: !showPrevButton}" class="page-link" aria-label="Previous">
                <span aria-hidden="true"><i class="far fa-angle-left"></i></span>
              </a>
            </li>
          </template>

          <li v-for="n in amountOfPages" class="page-item" :class="{active: (n + (pagerOffset * amountOfPagerItems )) == pageSelected }" @click="moveSelectedPageTo(n + (pagerOffset * amountOfPagerItems))">
            <a class="page-link">{{n + (pagerOffset * amountOfPagerItems )}}</a>
          </li>

          <li v-show="showMorePagesButton" class="page-item">
            <a class="page-link disable-hover">...</a>
          </li>

          <li v-show="showMorePagesButton" class="page-item" :class="{active: totalPages == pageSelected }" @click="moveSelectedPageTo(totalPages)">
            <a class="page-link">{{ totalPages }}</a>
          </li>

          <template class="icon-wrapper">
            <li class="page-item page-icon" @click="increaseSelectedPageIn(1)">
              <a :class="{disabled: !showNextButton}" class="page-link" aria-label="Next">
                <span aria-hidden="true"><i class="far fa-angle-right"></i></span>
              </a>
            </li>

            <li class="page-item page-icon"
                @click="increasePagerOffsetIn(1)">
              <a :class="{disabled: !showMorePagesButton}" class="page-link" aria-label="Next">
                <span aria-hidden="true"><i class="far fa-chevron-double-right"></i></span>
              </a>
            </li>
          </template>
        </ul>
      </nav>
    </div>
  </section>
</template>
<script lang="ts">
  import { onMounted, reactive, ref, computed, ComputedRef } from 'vue';

  interface IImage {
    url: string;
    alt: string;
  }

  interface IProject {
    id: string;
    title: string;
    summary: string;
    subtitle: string;
    description: string;
    primaryImage: IImage;
    galeryImages: IImage[];
    filters: string[];
    url: string;
    date: number;
  }

  interface IFilterOption {
    id: string;
    displayName: string;
    selected?: boolean;
  }

  interface IFilter {
    id: string;
    displayName: string;
    options: IFilterOption[];
  }

  interface IProjectPortfolioProps {
    projects: IProject[];
    filters: IFilter[];
  }

  enum SortingOption {
    newestToOldest,
    oldestToNewest,
    aZ,
    zA
  }

  export default {
    name: 'ProjectPortfolioList',
    props: {
      projects: {
        type: Object,
        required: true,
      },
      filters: {
        type: Array,
        required: true,
      },
    },
    setup(props: IProjectPortfolioProps) {
      const availableFilters = ref<IFilter[]>([]);
      const pageSelected = ref<number>(1);
      const itemsPerPage = ref<number>(12);
      const pagerOffset = ref<number>(0);
      const amountOfPagerItems = ref<number>(3);
      const sortingOption = ref<SortingOption>(0);

      const getSelectedFIlters = (): string[] => {
        return availableFilters.value.reduce((previous: any[], current) => previous.concat(current.options.filter(elm => elm.selected).map(item => item.id)), []);
      }

      const selectedFilters = computed(() => {
        return availableFilters.value.reduce((previous: any[], current) => previous.concat(current.options.filter(elm => elm.selected)), [])
      })

      const getAllProjectsFilteredBy = (selectedFilters: string[]): IProject[] => {
        return props.projects.filter(elm => selectedFilters.reduce((previous, current) => previous && elm.filters.includes(current), true))
      }

      const visibleProjects: ComputedRef<IProject[]> = computed(() => {
        const selectedFilters = getSelectedFIlters()

        let filtered: IProject[];

        if (selectedFilters.length > 0) {
          filtered = getAllProjectsFilteredBy(selectedFilters)
        } else {
          filtered = props.projects;
        }

        return filtered
          .sort((a, b) => {
            const dateA = new Date(a.date);
            const dateB = new Date(b.date);

            if (sortingOption.value == 0) {
              return dateB.valueOf() - dateA.valueOf();
            }
            if (sortingOption.value == 1) {
              return dateA.valueOf() - dateB.valueOf();
            }
            if (sortingOption.value == 2) {
              return a.title.localeCompare(b.title)
            }
            if (sortingOption.value == 3) {
              return b.title.localeCompare(a.title)
            }

            return dateB.valueOf() - dateA.valueOf();
          })
          .slice((pageSelected.value * itemsPerPage.value) - itemsPerPage.value, pageSelected.value * itemsPerPage.value);
      })

  const amountOfPages: ComputedRef<number> = computed(() => {
    const selectedFilters = getSelectedFIlters();

    let filtered: IProject[];
    if (selectedFilters.length > 0) {
      filtered = getAllProjectsFilteredBy(selectedFilters);
    } else {
      filtered = props.projects;
    }

    const amountOfItems = Math.floor(filtered.length / itemsPerPage.value) + 1;

    return Math.min(amountOfPagerItems.value, amountOfItems - (pagerOffset.value * amountOfPagerItems.value));
  })

  const handleFilterClick = (option: IFilterOption) => {
    availableFilters.value = availableFilters.value.map(elm => {
      return ({
        ...elm,
        options: elm.options.map(item => item.id == option.id ? { ...item, selected: !item.selected } : item)
      })
    })
  }

  const clearAllFilters = () => {
    availableFilters.value = availableFilters.value.map(elm => {
      return ({
        ...elm,
        options: elm.options.map(item => ({ ...item, selected: false }))
      })
    })
  }

  const showPrevButton: ComputedRef<boolean> = computed(() => {
    return pageSelected.value > 1
  })

  const totalPages: ComputedRef<number> = computed(() => {
    const selectedFilters = getSelectedFIlters();

    let filtered: IProject[];

    if (selectedFilters.length > 0) {
      filtered = getAllProjectsFilteredBy(selectedFilters);
    } else {
      filtered = props.projects;
    }

    return Math.floor(filtered.length / itemsPerPage.value) + 1;
  })

  const showNextButton: ComputedRef<boolean> = computed(() => {
    return pageSelected.value < totalPages.value;
  })

  const showMorePagesButton: ComputedRef<boolean> = computed(() => {
    return (totalPages.value - ((pagerOffset.value + 1) * amountOfPagerItems.value)) > 0;
  })

  const moveSelectedPageTo = (n: number) => {
    pageSelected.value = n
  }

  const setAmountOfItemsPerPageTo = (n: number) => {
    itemsPerPage.value = n;
  }

  const decreaseSelectedPageIn = (n: number) => {
    const page = Math.max(pageSelected.value - n, 1);
    const offset = Math.ceil(page / amountOfPagerItems.value) - 1;

    pageSelected.value = page;
    pagerOffset.value = offset >= 0 ? offset : pagerOffset.value;
  }

  const increaseSelectedPageIn = (n: number) => {
    const canIncreaseNPages = pageSelected.value + n <= totalPages.value;
    const page = canIncreaseNPages ? pageSelected.value + n : pageSelected.value;
    const offset = Math.ceil(page / amountOfPagerItems.value) - 1;

    pageSelected.value = page;
    pagerOffset.value = offset >= 0 ? offset : pagerOffset.value;
  }

  const decreasePagerOffsetIn = (n: number) => {
    const canDecrease = (pagerOffset.value - n) >= 0;

    if (canDecrease) {
      pagerOffset.value = pagerOffset.value - n;
    }
  }

  const increasePagerOffsetIn = (n: number) => {
    const canIncrease = showMorePagesButton;

    if (canIncrease) {
      pagerOffset.value = pagerOffset.value + n;
    }
  }

  onMounted(() => {
    availableFilters.value = props.filters
  })

  return {
    visibleProjects,
    selectedFilters,
    handleFilterClick,
    availableFilters,
    clearAllFilters,
    pageSelected,
    itemsPerPage,
    moveSelectedPageTo,
    amountOfPages,
    totalPages,
    pagerOffset,
    amountOfPagerItems,
    decreaseSelectedPageIn,
    increaseSelectedPageIn,
    decreasePagerOffsetIn,
    increasePagerOffsetIn,
    sortingOption,
    showPrevButton,
    showNextButton,
    showMorePagesButton,
    SortingOption
  }
    },
  };
</script>
